import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { ConversationPage } from "@/features/chat/components/conversation-page";
import { useI18n } from "@/providers/i18n-provider";

function ConversationRoutePage() {
  const { t } = useI18n();
  const params = chatThreadRoute.useParams();
  return (
    <AuthPlaceholder
      title={t(msg`Conversación`)}
      description={t(msg`Inicia sesión para ver esta conversación.`)}
    >
      <ConversationPage threadId={params().threadId} />
    </AuthPlaceholder>
  );
}

export const chatThreadRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/chat/$threadId",
  component: ConversationRoutePage,
});
